export const AlertDuration: number = 4000;
export const AlertDurationWithRedirect: number = 1000;
export const AlertPosition: string = "is-bottom is-center";
